module.exports = __webpack_public_path__ + "img/eye-closed-svgrepo-com.e636da55.svg";